export default __webpack_public_path__ + "static/media/curve_laptop.e83dc633.png";